module.exports = __webpack_public_path__ + "img/d-eco-en.a5cda178.png";